import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFlows } from "./redux/actions/integrationActions";
import {
  getCustomFields,
  checkJiraLicense,
  getJiraProjects,
  getJiraUserInfo,
  lookupAdminPermissionForUser,
  setAppWebLocationInJira
} from "./redux/actions/jiraActions";
import { getCreds } from "./redux/actions/credActions";
import AppFrame from "./navigation/AppFrame";
import MessageView from "./common/components/MessageView";
import { toggleLoading } from "./redux/actions/messageActions";
import { isJira } from "./connections/atlassian/ap";
import { checkForTokens } from "./redux/actions/authorizeActions";
import PublicRouter from "./Public/PublicRouter";
import { getNotifications } from "./redux/actions/notificationActions";
import { isJiraAdmin } from "./connections/atlassian/jira/jira.service";
import SectionMessage from "@atlaskit/section-message";
import {isEmptyJsonObject} from "./common/utils/helper"

const InitComponent = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.authorization.isLoggedIn);
  const jiraUser = useSelector((state) => state.jira.jiraUser);
  const adminPermission = useSelector((state) => state.jira.adminPermission);

  useEffect(() => {
    dispatch(checkForTokens());
    if (isLoggedIn && isJira()) {
      dispatch(getJiraUserInfo());
      dispatch(lookupAdminPermissionForUser());
      dispatch(setAppWebLocationInJira())
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isJiraAdmin(adminPermission)) {
      dispatch(toggleLoading(true, "Loading..."));
      dispatch(getFlows());
      dispatch(getCreds());
      dispatch(getNotifications());
      dispatch(getCustomFields());
      dispatch(checkJiraLicense());
      dispatch(getJiraProjects());
    }
  }, [jiraUser, adminPermission]);



  return (
    <div className="ihub-initcomponent">
      {isLoggedIn === true && isJiraAdmin(adminPermission) && (
        <>
          <MessageView />
          <AppFrame />
        </>
      )}
      {isLoggedIn === true && !isEmptyJsonObject(adminPermission) && !isJiraAdmin(adminPermission) && (
          <SectionMessage title="Admin Permission Required" appearance="error">
            <p>Integrations Hub for Jira requires admin permission.</p>
            <p>Contact your Jira administrator to get help.</p>
            <p>
              If you are an admin and still sees this message, please send a
              support request to support@rixter.se and we will assist you.
            </p>
          </SectionMessage>
      )}
      {!isJiraAdmin(adminPermission) && <PublicRouter />}
    </div>
  );
};

export default InitComponent;
